module.exports = __webpack_public_path__ + "43dc215bb4e9dd8f922f99608ecac043.svg";